import { Component, OnInit, Input } from '@angular/core';
import { IcecontrolSettings } from '../../components/models/icesettings';

declare var google: any;

var chartSettings = {};
var currentChart = "";

@Component({
  selector: 'icegooglechart',
  templateUrl: './icegooglechart.component.html',
  styleUrls: ['./icegooglechart.component.css']
})
export class IcegooglechartComponent implements OnInit {

  @Input() properties: any;
  @Input() ctrl: IcecontrolSettings = null;

  constructor() { }

  ngOnInit() {
  }
}
